<script setup lang="ts">
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  startIndex: {
    type: Number,
    required: true,
  },
  endIndex: {
    type: Number,
    required: true,
  },
});

const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);

const lookupWord = () => {
  console.log("lookupWord", props.text);
  thesaurusStore.lookupWordFromRoot(props.text, {
    documentText: {
      startIndex: props.startIndex,
      endIndex: props.endIndex,
      text: props.text,
    },
  });
  thesaurusStore.thesaurusEventEmitter.next({
    event: ThesaurusAction.openThesaurus,
  });
};
</script>

<template>
  <button
    class="bg-surface rounded-full shadow-[0_2px_4px_rgba(0,0,0,0.15)] ring-[1.5px] ring-[rgba(43,80,118,0.2)] w-4 h-4 flex items-center justify-center pointer-events-auto hover:scale-110 active:scale-95"
    v-tooltip="'Search for a word'"
    @click="lookupWord"
  >
    <BaseIconSearch class="text-[12px]" />
  </button>
</template>

<style scoped></style>
